import { groupDigits, orgLocale } from './org-locale';

/**
 * Formats per document 05: `INR 12,34,567.89` for India clients (lakh and crore grouping) and
 * `AED 1,234,567.89` for UAE clients (lib/org-locale), negatives with a leading minus, dates
 * dd/MM/yyyy, timestamps in the client's time zone.
 */
export function formatAmount(decimal: string | null | undefined): string {
  if (decimal === null || decimal === undefined || decimal === '') return '';
  const m = /^\s*(-)?(\d*)(?:\.(\d*))?\s*$/.exec(decimal);
  if (!m || (m[2] === '' && (m[3] ?? '') === '')) return decimal;
  // exact on the decimal string (no floats): round half up to 2 places
  const frac = (m[3] ?? '').padEnd(3, '0');
  let cents = BigInt(`${m[2] || '0'}${frac.slice(0, 2)}`);
  if (Number(frac[2]) >= 5) cents += 1n;
  const s = cents.toString().padStart(3, '0');
  const neg = m[1] && cents !== 0n;
  return `${neg ? '-' : ''}${groupDigits(s.slice(0, -2))}.${s.slice(-2)}`;
}

export function formatMoney(decimal: string | null | undefined, currency: string): string {
  const a = formatAmount(decimal);
  return a ? `${currency} ${a}` : '';
}

const dateFormat = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return dateFormat.format(new Date(Date.UTC(y, m - 1, d)));
}

const dateTimeFormats = new Map<string, Intl.DateTimeFormat>();

/** A timestamp in the client's time zone (India or UAE time): `14/10/2026, 09:05`. */
export function formatDateTime(iso: string): string {
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return iso;
  const timeZone = orgLocale().timeZone;
  let f = dateTimeFormats.get(timeZone);
  if (!f) {
    f = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone,
    });
    dateTimeFormats.set(timeZone, f);
  }
  return f.format(t);
}
